export default {
  // Layout
  'site.header.apartments': 'Apartments and Hotels',
  'site.currency': 'Currency',
  'site.language': 'Language',
  'site.currencySelector': 'Currency selector',
  'site.languageSelector': 'Language selector',
  'site.menu': 'Menu',
  'site.signIn': 'Sign in',
  'site.signOut': 'Sign out',
  'site.signOutConfirmTitle': 'Sign out?',
  'site.signOutConfirmBody': 'Are you sure you want to sign out?',
  'site.signOutStay': 'Stay signed in',
  'site.openMenu': 'Open menu',
  'site.footer.copyright': 'All rights reserved.',
  'site.footer.manageBooking': 'Manage your booking',
  'site.footer.terms': 'Terms & Conditions',
  'site.footer.privacy': 'Privacy Policy',
  'site.trust.bestPrice': 'Best Price Guarantee',
  'site.trust.bestPriceDesc': 'Get the best rates.',
  'site.trust.flexibleBooking': 'Flexible Booking',
  'site.trust.flexibleBookingDesc': 'Easy changes & cancellations.',
  'site.trust.securePayments': 'Secure Payments',
  'site.trust.securePaymentsDesc': 'Trusted & safe checkout.',
  'site.trust.localSupport': 'Local Support',
  'site.trust.localSupportDesc': "We're here to help anytime.",

  // Home
  'home.heroTitle': 'Find your perfect stay',
  'home.inAustralia': 'in Australia',
  'home.heroSubtitle': 'Apartments and hotels for every kind of stay',
  'home.errorLoading': 'Properties could not be loaded.',
  'home.noPropertiesTitle': 'No properties available right now.',
  'home.noPropertiesDescription': 'Try searching for a destination to explore available stays.',
  'home.exploreStays': 'Explore stays',
  'home.property': 'property',
  'home.property_one': 'property',
  'home.property_other': 'properties',
  'home.properties': 'properties',
  'home.foundInAustralia': 'found in Australia',

  // Search
  'search.errorLoading': 'Availability could not be loaded. Please try again.',
  'search.noResults': 'No properties match your search criteria.',
  'search.mapFollow': 'Search as I move the map',
  'search.chooseLocationTitle': 'Choose a location',
  'search.chooseLocationDescription': 'Select a destination before searching for available stays.',
  'search.chooseDatesTitle': 'Choose your dates',
  'search.pastCheckIn': 'Check-in cannot be in the past.',
  'search.checkOutAfterCheckIn': 'Check-out must be after check-in.',
  'search.property': 'property',
  'search.property_one': 'property',
  'search.property_other': 'properties',
  'search.properties': 'properties',
  'search.found': 'found',

  // Search widget
  'widget.where': 'Where',
  'widget.location': 'Location',
  'widget.checkInOut': 'Check-in / Check-out',
  'widget.guests': 'Guests',
  'widget.rooms': 'Rooms',
  'widget.promoCode': 'Promo Code',
  'widget.promoPlaceholderCompact': 'Add code (optional)',
  'widget.promoPlaceholder': 'Optional',
  'widget.search': 'Search',
  'widget.update': 'Update',
  'widget.adult': 'Adult',
  'widget.adults': 'Adults',
  'widget.child': 'Child',
  'widget.children': 'Children',
  'widget.decreaseAdults': 'Decrease adults',
  'widget.increaseAdults': 'Increase adults',
  'widget.decreaseChildren': 'Decrease children',
  'widget.increaseChildren': 'Increase children',
  'widget.room': 'Room',
  'widget.adultOption': '{count} Adults',
  'widget.adultOption_one': '{count} Adult',
  'widget.adultOption_other': '{count} Adults',
  'widget.childOption': '{count} Children',
  'widget.childOption_one': '{count} Child',
  'widget.childOption_other': '{count} Children',
  'widget.roomOption': '{count} Rooms',
  'widget.roomOption_one': '{count} Room',
  'widget.roomOption_other': '{count} Rooms',
  'widget.guestCount': '{count} guests',
  'widget.guestCount_one': '{count} guest',
  'widget.guestCount_other': '{count} guests',
  'widget.roomCount': '{count} rooms',
  'widget.roomCount_one': '{count} room',
  'widget.roomCount_other': '{count} rooms',
  'widget.locationError': 'Locations could not be loaded. Please try again.',
  'widget.searchAria': 'Search availability',
  'widget.dateErrorRequired': 'Please select both check-in and check-out dates.',
  'widget.dateErrorPast': 'Check-in cannot be in the past.',
  'widget.dateErrorRange': 'Check-out must be after check-in.',
  'widget.dateRange.placeholder': 'Select check-in & check-out dates',
  'widget.dateRange.selectCheckout': 'Select checkout',
  'widget.dateRange.aria.checkIn': 'Check-in',
  'widget.dateRange.aria.checkOut': 'Check-out',
  'widget.dateRange.aria.picker': 'Check-in / Check-out date range picker',
  'widget.dateRange.previousMonth': 'Previous month',
  'widget.dateRange.nextMonth': 'Next month',
  'widget.dateRange.selectCheckIn': 'Select check-in date',
  'widget.dateRange.selectCheckOut': 'Select check-out date',
  'widget.dateRange.resetToday': 'Reset to Today',
  'widget.dateRange.done': 'Done',

  // Property / availability
  'property.heroAlt': 'Property hero',
  'property.fallbackName': 'Selected property by {site}',
  'property.chooseRoom': 'Choose your room',
  'property.filterBy': 'Filter by:',
  'property.filterAll': 'All Rooms',
  'property.filterStudios': 'Studios',
  'property.filter1Bed': '1 Bedroom',
  'property.filter2Bed': '2 Bedrooms',
  'property.filterApartments': 'Apartments',
  'property.sortBy': 'Sort by:',
  'property.sortRecommended': 'Recommended',
  'property.sortPriceLow': 'Price: Low to High',
  'property.sortPriceHigh': 'Price: High to Low',
  'property.errorLoading': 'Availability could not be loaded. Please try again.',
  'property.noRooms': 'No rooms available',
  'property.noRoomsDescription': 'Try different dates or occupancy.',
  'property.totalForNights': 'Total for {nights} nights',
  'property.perNight': 'per night',
  'property.night': 'night',
  'property.night_one': 'night',
  'property.night_other': 'nights',
  'property.nights': 'nights',
  'property.freeCancellation': 'Free cancellation',
  'property.selectRoom': 'Select room',
  'property.selected': 'Selected',
  'property.continue': 'Continue',
  'property.previousPhoto': 'Previous photo',
  'property.nextPhoto': 'Next photo',
  'property.addToWishlist': 'Add to wishlist',
  'property.popularChoice': 'Popular choice',
  'property.showMore': 'Show more',
  'property.showLess': 'Show less',
  'property.maxOccupancy': 'Max Occupancy:',
  'property.size': 'Size:',
  'property.bedType': 'Bed Type:',
  'property.roomAmenities': 'Room Amenities',
  'property.showMoreAmenities': '+{count} more',
  'property.guests': 'Guests',
  'property.adults': 'Adults',
  'property.children': 'Children',
  'property.onlyRoomsLeft': 'Only {count} rooms left',
  'property.onlyRoomsLeft_one': 'Only {count} room left',
  'property.onlyRoomsLeft_other': 'Only {count} rooms left',
  'property.lastBookedMinutes': 'Last booked {count} minutes ago',
  'property.lastBookedMinutes_one': 'Last booked {count} minute ago',
  'property.lastBookedMinutes_other': 'Last booked {count} minutes ago',
  'property.lastBookedHours': 'Last booked {count} hours ago',
  'property.lastBookedHours_one': 'Last booked {count} hour ago',
  'property.lastBookedHours_other': 'Last booked {count} hours ago',
  'property.lastBookedDays': 'Last booked {count} days ago',
  'property.lastBookedDays_one': 'Last booked {count} day ago',
  'property.lastBookedDays_other': 'Last booked {count} days ago',
  'property.checkInTime': 'Check-in {time}',
  'property.checkOutTime': 'Check-out {time}',
  'property.compare': 'Compare',
  'property.taxesIncluded': 'per night including taxes & fees',
  'property.chooseRate': 'Choose your rate',
  'property.yourSelection': 'Your selection',
  'property.aboutRoom': 'About this room',
  'property.roomDetails': 'Room details',
  'property.selectedProperty': 'Selected property by {site}',
  'property.backToRooms': 'Back to rooms',
  'property.standardRate': 'Standard Rate',
  'property.noPromotion': 'No promotion available for this rate.',
  'property.youSave': 'You save ({percent}% off) - {amount}',
  'property.inclusions': 'Inclusions:',
  'property.viewAllPhotos': 'View all photos',
  'property.seeOnMap': 'See on map',

  // Room type card
  'room.perNight': 'night',
  'room.sleeps': 'Sleeps',
  'room.thumbnailAlt': 'Thumbnail',
  'room.available': 'available',
  'room.select': 'Select',
  'room.selected': 'Selected',

  // Property card
  'card.viewAvailability': 'View availability',
  'card.from': 'From',
  'card.night': 'night',
  'card.checkAvailability': 'Check Availability',
  'card.saveToFavourites': 'Save to favourites',
  'card.ratingExcellent': 'Excellent',
  'card.ratingVeryGood': 'Very good',
  'card.ratingGood': 'Good',
  'card.ratingGuest': 'Guest rating',

  // Guest details
  'guest.stepChooseRoom': 'Choose Room',
  'guest.stepGuestDetails': 'Guest Details',
  'guest.stepPayment': 'Payment',
  'guest.stepConfirmation': 'Confirmation',
  'guest.title': 'Enter Guest Details',
  'guest.subtitle': 'Please provide your information.',
  'guest.firstName': 'First name',
  'guest.lastName': 'Last name',
  'guest.email': 'Email',
  'guest.emailHint': 'Booking confirmation will be sent to this email.',
  'guest.country': 'Country',
  'guest.selectCountry': 'Select country',
  'guest.searchCountry': 'Search countries…',
  'guest.loadingCountries': 'Loading countries…',
  'guest.loadingSuburbs': 'Loading suburbs…',
  'guest.noSuburbsFound': 'No suburbs found',
  'guest.selectedSuburb': 'Selected: {suburb}',
  'guest.postalCode': 'Postal code',
  'guest.phone': 'Phone number',
  'guest.phoneCountryCode': 'Country code',
  'guest.phonePlaceholder': 'Enter phone number',
  'guest.address': 'Address',
  'guest.city': 'City',
  'guest.specialRequests': 'Special requests (optional)',
  'guest.specialRequestsPlaceholder': 'Any special requests?',
  'guest.termsPrefix': 'By completing this booking, I agree to the',
  'guest.terms': 'Terms & Conditions',
  'guest.termsAnd': 'and',
  'guest.privacy': 'Privacy Policy',
  'guest.termsSuffix': ', and I accept the booking conditions.',
  'guest.marketingOptOut': 'I do not want to receive marketing messages.',
  'guest.cardVerify':
    'A temporary {amount} card verification hold will be placed. You will not be charged now.',
  'guest.chargeNow': 'Your card will be charged {amount} now.',
  'guest.payOnArrival': 'Payment will be collected at the property.',
  'guest.noRoomsSelected': 'No rooms selected.',
  'guest.noPropertySelected': 'No property selected.',
  'guest.paymentStillLoading': 'Payment options are still loading. Please try again in a moment.',
  'guest.submitProcessing': 'Processing…',
  'guest.submitVerifyCard': 'Verify card and confirm booking',
  'guest.submitConfirm': 'Confirm booking',

  // Checkout
  'checkout.backToRooms': 'Back to room selection',
  'checkout.bookingSummary': 'Your booking summary',
  'checkout.noRooms': 'No rooms in this booking — add one below.',
  'checkout.edit': 'Edit',
  'checkout.remove': 'Remove',
  'checkout.removeTitle': 'Remove this room?',
  'checkout.removeBody':
    "{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': 'Cancel',
  'checkout.removeConfirm': 'Remove room',
  'checkout.duration': 'Duration of stay',
  'checkout.occupancy': 'Occupancy',
  'checkout.occupancyValue': '{adults} Adults, {children} Children',
  'checkout.ratePlan': 'Rate Plan',
  'checkout.policies': 'Cancellation & Payment Policies',
  'checkout.roomRequests': 'Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    'Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': 'Sub Total',
  'checkout.accommodationFees': 'Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': 'Taxes & fees',
  'checkout.memberSavings': 'Member savings',
  'checkout.promotionSavings': 'Savings',
  'checkout.total': 'Total',
  'checkout.totalCaption': 'Includes taxes & fees',
  'checkout.propertyCurrencyTitle': 'Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': 'Add another room',
  'checkout.memberTitle': 'Join as a member now — membership is free',
  'checkout.memberTitleWithSaving': 'Join as a member now — save {amount} on this booking',
  'checkout.memberBody': 'Member discounts apply before you pay.',
  'checkout.memberJoin': 'Join free',
  'checkout.memberSignIn': 'Sign in',
  'checkout.memberJoinInline': 'Join as a member using the details above',
  'checkout.memberJoinInlineHint': 'Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': 'Member total',
  'checkout.memberSaveCaption': 'You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': 'Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    'Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': 'Proceed to payment',
  'checkout.processing': 'Processing your booking…',
  'checkout.processingDoNotClose':
    'Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose': 'Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': 'Applying member rates to your stay…',
  'checkout.loadingProfile': 'Loading your member details…',
  'checkout.preparingPayment': 'Preparing secure payment…',
  'checkout.termsHint': 'The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment': 'Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '{checkIn} – {checkOut} • {nights} nights',

  // Payment
  'payment.title': 'Payment',
  'payment.method': 'Payment method',
  'payment.cardDetailsHint':
    'Enter your card details securely below. Your card details are tokenized and never touch our servers.',
  'payment.loadingForm': 'Loading payment form…',
  'payment.formUnavailable': 'Payment form unavailable.',
  'payment.acceptTerms': 'I accept the terms and conditions and cancellation policy.',
  'payment.payNow': 'Pay now',
  'payment.processing': 'Processing…',
  'payment.noRoomsSelected': 'No rooms selected.',
  'payment.redirecting': 'Redirecting to the secure payment page…',
  'payment.notConfigured': 'Quickstream is not configured for this property.',
  'payment.noScript': 'Quickstream payment service could not be loaded. Please refresh the page.',
  'payment.formNotLoaded': 'Payment form not loaded. Please refresh the page.',
  'payment.cardDetails': 'Payment failed. Please check your card details.',
  'payment.tokenizationFailed': 'Card tokenization failed. Please try again.',
  'payment.failed': 'Payment failed.',
  'payment.statusResult': 'Payment status: {status}. Please try again.',

  // Confirmation
  'confirmation.loading': 'Loading your booking…',
  'confirmation.notFound': 'Booking not found. Check your booking reference and try again.',
  'confirmation.errorGeneric': 'Your booking could not be confirmed. Please contact support.',
  'confirmation.errorLoadDetails': 'Could not load reservation details.',
  'confirmation.couldNotComplete': "We couldn't complete your payment",
  'confirmation.startNew': 'Start a new booking',
  'confirmation.tryPaymentAgain': 'Try payment again',
  'confirmation.paymentNotFound': 'Payment session could not be found. Please contact support.',
  'confirmation.paymentStateInvalid':
    'Payment is not in a valid state to complete. Please start again.',
  'confirmation.paymentFailedDeclined':
    'Your payment could not be completed. Please check your card details and try again, or use a different payment method.',
  'confirmation.paymentTimeout': 'Payment took too long. Please try again.',
  'confirmation.paymentGatewayUnavailable':
    'The payment system is temporarily unavailable. Please try again in a few moments.',
  'confirmation.paymentUnknown': 'Payment could not be confirmed: {message}.',
  'confirmation.paymentGenericError':
    'Payment could not be confirmed. Please try again or contact support.',

  // Booking summary
  'summary.title': 'Your Booking Summary',
  'summary.yourBooking': 'Your Booking Summary',
  'summary.noRoomsSelected': 'No rooms selected yet.',
  'summary.checkIn': 'CHECK-IN',
  'summary.checkOut': 'CHECK-OUT',
  'summary.lengthOfStay': 'Length of stay',
  'summary.guests': 'Guests',
  'summary.nights': '{nights} nights',
  'summary.nights_one': '{nights} night',
  'summary.nights_other': '{nights} nights',
  'summary.totalForNights': 'Total for {nights} nights',
  'summary.includingTaxes': 'Including taxes & fees',
  'summary.discount': 'Save {amount}',
  'summary.checkInFrom': 'From {time}',
  'summary.checkOutUntil': 'Until {time}',
  'summary.cancellationUntil': 'until {date}',

  // Reservation detail
  'detail.confirmed': 'Booking confirmed!',
  'detail.received': 'Booking received',
  'detail.referenceIntro': 'Your booking reference is',
  'detail.reservationId': 'Reservation id:',
  'detail.processing':
    'Your booking is being processed. You will receive a confirmation email once payment is confirmed.',
  'detail.guest': 'Guest',
  'detail.rooms': 'Rooms',
  'detail.night': 'night',
  'detail.nights': 'nights',
  'detail.adult': 'adult',
  'detail.adults': 'adults',
  'detail.child': 'child',
  'detail.infant': 'infant',
  'detail.priceBreakdown': 'Price breakdown',
  'detail.subtotal': 'Subtotal',
  'detail.taxes': 'Taxes',
  'detail.fees': 'Fees',
  'detail.discounts': 'Discounts',
  'detail.surcharge': 'Card surcharge',
  'detail.grandTotal': 'Grand total',

  // Price breakdown
  'priceBreakdown.roomSubtotal': 'Room subtotal',
  'priceBreakdown.total': 'Total',

  'detail.deposit': 'Deposit',
  'detail.depositDueBy': 'due by',
  'detail.arrival': 'arrival',
  'detail.specialRequests': 'Special requests',
  'detail.backToHome': 'Back to home',
  'detail.confirmationSentTo': 'A confirmation email has been sent to',
  'detail.bookingReference': 'Booking reference',
  'detail.address': 'Address',
  'detail.guestDetails': 'Guest details',
  'detail.name': 'Name',
  'detail.email': 'Email',
  'detail.phone': 'Mobile number',
  'detail.status': 'Status',
  'detail.card': 'Card',
  'detail.paidInFull': 'Paid in full',
  'detail.partiallyPaid': 'Partially paid',
  'detail.paidOnline': 'Paid online',
  'detail.dueAtProperty': 'Due at property',
  'detail.bookedOn': 'Booked on',
  'detail.roomTotal': 'Room total',
  'detail.roomsCount': 'Rooms ({count})',
  'detail.yourRoom': 'Your room',
  'detail.roomNumber': 'Room {number}',
  'detail.priceSummary': 'Price summary',
  'detail.chargedInPropertyCurrency': 'Charged in property currency ({currency})',
  'detail.totalPaid': 'Total paid',
  'detail.plansChanged': 'Plans changed?',
  'detail.plansChangedBody':
    'Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': 'Print confirmation',
  'detail.questions':
    'Questions? Reply to your confirmation email or contact the property directly.',

  // Shared
  'shared.retry': 'Retry',
  'shared.close': 'Close',
  'shared.back': 'Back',
  'shared.previous': 'Previous',
  'shared.next': 'Next',

  // Validation
  'validation.firstNameRequired': 'First name is required',
  'validation.lastNameRequired': 'Last name is required',
  'validation.emailRequired': 'Valid email is required',
  'validation.phoneRequired': 'Phone number is required',
  'validation.addressRequired': 'Address is required',
  'validation.cityRequired': 'City is required',
  'validation.countryRequired': 'Country is required',
  'validation.postalCodeRequired': 'Postal code is required',

  // Errors
  'error.pmsUnavailable':
    'Sorry, this room is no longer available for your selected dates. Please go back and choose different dates or another room.',
  'error.pmsSyncError':
    'We could not connect with the property system. Please try again in a few moments.',
  'error.paymentNotConfigured':
    'Payment is not configured for this property. Please choose another property or contact support.',
  'error.paymentStartFailed': 'Something went wrong while starting payment. Please try again.',
  'error.bookingFailed': 'Booking failed. Please try again.',
  'error.quoteAlreadyConverted':
    'This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    'A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',

  // Site / document titles
  'site.title.default': 'Book your stay',
  'site.title.suffix': 'Apartments and Hotels',
  'site.title.home': 'Home',
  'site.title.search': 'Search',
  'site.title.property': 'Property',
  'site.title.room': 'Room',
  'site.title.guestDetails': 'Guest Details',
  'site.title.payment': 'Payment',
  'site.title.confirmation': 'Booking Confirmed',
  'site.title.bookingLookup': 'Find your booking',
  'site.title.bookingDetails': 'Booking details',
  'site.title.cancellation': 'Cancel booking',
  'site.title.reservationDetail': 'Reservation details',
  'site.title.signIn': 'Sign in',
  'site.title.signUp': 'Sign up',
  'site.title.notFound': 'Page not found',

  // Not found
  'notFound.title': 'Page not found',
  'notFound.message': 'The page you are looking for does not exist.',
  'notFound.backHome': 'Back to home',

  // Home
  'home.heroAlt': 'Australia city skyline',
  'home.featuredProperties': 'Featured properties',
  'home.popularDestinations': 'Popular destinations',

  // Common / misc
  'common.reviews': '{count} reviews',
  'common.reviews_one': '{count} review',
  'common.reviews_other': '{count} reviews',
  'common.loading': 'Loading',
  'common.pleaseWait': 'Please wait while we load your results',
  'common.of': 'of',
  'common.select': 'Select…',
  'common.search': 'Search…',
  'common.selectLocation': 'Select a location',
  'location.propertyCount': '{count} properties',
  'location.propertyCount_one': '{count} property',
  'location.propertyCount_other': '{count} properties',
  'location.roomsAvailable': '{count} rooms available',
  'location.roomsAvailable_one': '{count} room available',
  'location.roomsAvailable_other': '{count} rooms available',
  'map.suburb.newstead': 'Newstead',
  'map.suburb.fortitudeValley': 'Fortitude Valley',
  'map.suburb.paddington': 'Paddington',
  'map.suburb.bardon': 'Bardon',
  'map.suburb.brisbane': 'Brisbane',
  'map.suburb.southBrisbane': 'South Brisbane',
  'map.suburb.kangarooPoint': 'Kangaroo Point',
  'map.suburb.stLucia': 'St Lucia',
  'map.suburb.moorooka': 'Moorooka',
  'map.suburb.annerley': 'Annerley',
  'map.suburb.mtGravatt': 'Mt Gravatt',
  'common.noOptions': 'No options available',
  'common.code': 'Code',
  'common.searchCode': 'Search code…',

  // Property filter sidebar
  'filter.title': 'Filters',
  'filter.price': 'Price',
  'filter.priceMinimum': 'Minimum',
  'filter.priceMaximum': 'Maximum',
  'filter.priceMinPlaceholder': '$0',
  'filter.priceMaxPlaceholder': '$500+',
  'filter.propertyType': 'Property Type',
  'filter.propertyType.hotel': 'Hotel',
  'filter.propertyType.apartment': 'Apartment',
  'filter.propertyType.resort': 'Resort',
  'filter.amenities': 'Amenities',
  'filter.amenity.pool': 'Pool',
  'filter.amenity.parking': 'Parking',
  'filter.amenity.breakfast': 'Breakfast included',
  'filter.rating': 'Rating',
  'filter.rating.any': 'Any rating',
  'filter.rating.5': '5 stars',
  'filter.rating.4': '4 stars and above',
  'filter.rating.3': '3 stars and above',
  'filter.more': 'More',
  'filter.more.freeCancellation': 'Free cancellation',
  'filter.more.payAtProperty': 'Pay at property',
  'filter.clear': 'Clear',
  'filter.apply': 'Apply filters',

  // Property card
  'card.reviews_one': 'review',
  'card.reviews_other': 'reviews',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': 'show more',
  'card.showLess': 'show less',

  // Guest selector
  'widget.childrenAgeHint': 'Ages 0 - 12',

  // Auth
  'auth.orContinueWith': 'Or continue with',
  'auth.signIn.title': 'Sign in to your account',
  'auth.signIn.subtitle':
    'Welcome back! Sign in to manage your bookings, view your stays and access exclusive offers.',
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'Enter your email address',
  'auth.emailRequired': 'Email is required.',
  'auth.emailInvalid': 'Please enter a valid email address.',
  'auth.password': 'Password',
  'auth.passwordPlaceholder': 'Enter your password',
  'auth.createPasswordPlaceholder': 'Create a password',
  'auth.passwordRequired': 'Password is required.',
  'auth.passwordMinLength': 'Password must be at least {min} characters.',
  'auth.passwordPattern': 'Password must include letters and numbers.',
  'auth.passwordHint': 'Use at least {min} characters with a mix of letters, numbers and symbols.',
  'auth.showPassword': 'Show password',
  'auth.hidePassword': 'Hide password',
  'auth.keepSignedIn': 'Keep me signed in',
  'auth.forgotPassword': 'Forgot password?',
  'auth.forgot.title': 'Reset your password',
  'auth.forgot.subtitle':
    'Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': 'Send reset link',
  'auth.forgot.sending': 'Sending...',
  'auth.forgot.success':
    'If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': 'Back to sign in',
  'auth.reset.title': 'Choose a new password',
  'auth.reset.subtitle': 'Enter a new password for your account.',
  'auth.reset.submit': 'Reset password',
  'auth.reset.saving': 'Resetting...',
  'auth.reset.success': 'Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken': 'This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': 'Go to sign in',
  'auth.verify.title': 'Verify your email',
  'auth.verify.verifying': 'Verifying your email address…',
  'auth.verify.success': 'Your email address has been verified. You can sign in now.',
  'auth.verify.error': 'We could not verify this link.',
  'auth.verify.missingToken':
    'This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    'The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': 'Go to sign in',
  'auth.verify.resend': 'Resend verification email',
  'auth.verify.sending': 'Sending email…',
  'auth.verify.resent': 'Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': 'Sign in',
  'auth.signingIn': 'Signing in...',
  'auth.signInError': 'Sign in failed. Please try again.',
  'auth.googleError': 'Google sign-in failed.',
  'auth.noAccount': "Don't have an account?",
  'auth.createAccount': 'Create an account',
  'auth.signUp.title': 'Create your account',
  'auth.signUp.subtitle':
    'Join {site} to manage your bookings, save your favourite properties and get exclusive offers.',
  'auth.firstName': 'First name',
  'auth.firstNamePlaceholder': 'Enter your first name',
  'auth.firstNameRequired': 'First name is required.',
  'auth.lastName': 'Last name',
  'auth.lastNamePlaceholder': 'Enter your last name',
  'auth.lastNameRequired': 'Last name is required.',
  'auth.mobile': 'Mobile number',
  'auth.mobilePlaceholder': 'Enter your mobile number',
  'auth.dialingCode': 'Country dialing code',
  'auth.mobileRequired': 'Mobile number is required.',
  'auth.mobileInvalid': 'Please enter a valid mobile number.',
  'auth.confirmPassword': 'Confirm password',
  'auth.confirmPasswordPlaceholder': 'Confirm your password',
  'auth.termsAgree': 'I agree to the',
  'auth.termsRequired': 'You must agree to the Terms & Conditions and Privacy Policy.',
  'auth.marketingConsent':
    'I would like to receive exclusive offers and travel inspiration from {site}',
  'auth.signUpError': 'Could not create account. Please try again.',
  'auth.signUp': 'Sign up',
  'auth.creatingAccount': 'Creating account...',
  'auth.createAccountButton': 'Create account',
  'auth.alreadyHaveAccount': 'Already have an account?',
  'auth.passwordMismatch': 'Passwords do not match.',

  // Pricing page
  'pricing.title': 'Pricing summary',
  'pricing.noRoomsSelected': 'No rooms selected. Please go back and select rooms.',
  'pricing.backToAvailability': 'Back to availability',
  'pricing.continue': 'Continue to guest details',

  // Room detail
  'property.youSavePercent': 'You save ({percent}% off)',
  'property.includingTaxesFees': '(incl. taxes & fees)',
  'map.zoomIn': 'Zoom in',
  'map.zoomOut': 'Zoom out',
  'map.viewFullMap': 'View in full map',
  'booking.progress': 'Booking progress',
  'reservationDetail.resetAria': 'Reset booking state',

  // Booking management
  'bookingLookup.title': 'Find your booking',
  'bookingLookup.description':
    'Enter your booking reference and email to view, modify, or cancel your reservation.',
  'bookingLookup.bookingReference': 'Booking reference',
  'bookingLookup.placeholder': 'e.g. SYD-260815-0001',
  'bookingLookup.lookingUp': 'Looking up…',
  'bookingLookup.findBooking': 'Find booking',
  'bookingLookup.notFound':
    'Booking not found. Try BK-2026-001, alex.morgan@example.com and Morgan.',

  'cancellation.title': 'Cancel booking',
  'cancellation.property': 'Property',
  'cancellation.details': 'Cancellation details',
  'cancellation.penalty': 'Cancellation penalty',
  'cancellation.refund': 'Refund amount',
  'cancellation.totalPaid': 'Total paid:',
  'cancellation.reasonLabel': 'Reason for cancellation (optional)',
  'cancellation.understand': 'I understand this action cannot be undone.',
  'cancellation.cancelledDemo':
    'Your booking has been cancelled in this UI demo. Refund amount: {{refundAmount}}.',
  'cancellation.confirm': 'Confirm cancellation',
  'cancellation.notFound': 'Booking not found.',
  'bookingDetails.title': 'Booking details',
  'bookingDetails.notFound': 'Booking not found.',
  'bookingDetails.checkIn': 'Check-in:',
  'bookingDetails.checkOut': 'Check-out:',
  'bookingDetails.rooms': 'Rooms',
  'bookingDetails.guest': 'Guest',
  'bookingDetails.freeCancellationUntil': 'Free cancellation until {date}',
  'bookingDetails.total': 'Total:',
  'reservationDetail.loading': 'Loading your booking…',
  'reservationDetail.noReference': 'No booking reference provided.',
  'reservationDetail.loadError': 'Could not load reservation details.',

  // Site footer
  'site.footer.brand': 'BookYourStay',

  // Shared / controls
  'common.loadingLocations': 'Loading locations…',
  'common.couldNotLoadLocations': 'Could not load locations',
  'common.searchLocationPlaceholder': 'Search country, city or property',
  'common.collapse': 'Collapse',
  'common.expand': 'Expand',

  // Map
  'map.loadingGoogle': 'Loading Google Map…',
  'map.errorGoogle': 'Failed to load Google Maps',
  'map.errorMap': 'Failed to load map.',
  'map.greatLocation': 'Great location',

  // Trust badges (home)
  'home.trust.secureBooking': 'Secure Booking',
  'home.trust.secureBookingDesc': 'Your information is safe with us.',
  'home.trust.bestPrice': 'Best Price Guarantee',
  'home.trust.bestPriceDesc': "Found a lower price? We'll match it.",
  'home.trust.localSupport': '24/7 Support',
  'home.trust.localSupportDesc': "We're here to help anytime.",
  'home.trust.flexibleBooking': 'Flexible Options',
  'home.trust.flexibleBookingDesc': 'Free cancellation on selected rates.',

  // Promotions
  'promotion.memberPromo': 'Member Promo',
  'promotion.save': 'Save',

  // Property / room detail
  'property.memberRate': 'Member Rate',
  'property.hideAmenities': 'Hide amenities',
  'property.showAllAmenities': 'Show all amenities',
  'property.chooseRatePromo': 'Choose your preferred rate - Member rates offer exclusive savings!',

  // Room rate / room info pages
  'roomRate.stepChooseStay': 'Choose your stay',
  'roomRate.stepCheckout': 'Checkout',
  'roomRate.stepConfirmation': 'Confirmation',
  'roomRate.membersSaveUpTo': 'Members save up to {percent}%',
  'roomRate.membersSaveMore': 'Members save more',
  'roomRate.memberSignInHint': 'Sign in or join free during checkout to unlock member rates.',
  'roomRate.from': 'FROM',
  'roomRate.perNightSuffix': '/ night',
  'roomRate.nonMemberFrom': 'Non-member rate from {price}',
  'roomRate.taxesIncluded': 'Rates include taxes & fees',
  'roomRate.taxesExcluded': 'Rates exclude taxes & fees',
  'roomRate.inclTaxes': 'incl. taxes & fees',
  'roomRate.exclTaxes': 'excl. taxes & fees',
  'roomRate.includesTaxes': 'Includes taxes and fees',
  'roomRate.excludesTaxes': 'Excludes taxes and fees',
  'roomRate.bookNow': 'Book now',
  'roomRate.selectRate': 'Select this rate',
  'roomRate.bestValue': 'Best Value',
  'roomRate.onlyLeftAtPrice': 'Only {count} left at this price',
  'roomRate.fullDetails': 'Full room details',
  'roomRate.loadMoreRates': 'Load more rates',
  'roomRate.showLessRates': 'Show less rates',
  'roomRate.vsNonMemberTotal': 'vs non-member total of {total}',
  'roomRate.youSave': 'You save {amount} ({percent}% off)',
  'roomRate.totalForNights': '{total} total • {nights} nights',
  'roomRate.nightTimes': '{nights} nights × {perNight}',
  'roomRate.totalLine': '{total} total • {taxNote}',
  'roomRate.notMemberYet':
    'Not a member yet? Join during checkout — the member price still applies.',
  'roomRate.promoApplied': 'Promo {code} applied',
  'roomRate.promotions': 'Promotions',
  'roomRate.promoSaveSuffix': 'Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': 'Save - {amount}',
  'roomRate.promoStayPaySuffix': 'Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': 'Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': 'Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': 'Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': 'Special rate — {rate} per night',
  'roomRate.memberLocked': 'Member-only promotion',
  'roomRate.memberUnlockTitle': 'Sign in or join to unlock',
  'roomRate.memberUnlockSaving': 'member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': 'Member rate includes',
  'roomRate.memberBenefitRatesTitle': 'Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody': 'Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': 'Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': 'Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    'Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': 'Free to join',
  'roomRate.memberBenefitJoinBody': 'Create an account in seconds during checkout.',
  'roomRate.joinFree': 'Join free',
  'roomRate.joinFreeCta': 'Sign in or join free',
  'roomRate.alreadyMember': 'Already a member?',
  'roomRate.alreadyMemberHint': 'Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': 'View other room types',
  'roomRate.view': 'View',
  'roomRate.freeCancelUntil': 'Free cancellation until {date}',
  'roomRate.upsell': 'Recommended alternative',
  'roomRate.roomsIncluded': '{count} rooms included',
  'roomRate.nightlyBreakdown': 'Night-by-night price',
  'roomRate.previousRate': 'Previous rate',
  'roomRate.nextRate': 'Next rate',

  // Property card
  'card.discount': '-{percent}% off',

  // Gallery
  'gallery.imageAlt': '{title} view {current} of {total}',
  'gallery.thumbnailAlt': 'Go to view {current} of {total}',
  'gallery.previewAlt': '{title} preview',

  // Reservation detail pluralization
  'detail.night_one': 'night',
  'detail.night_other': 'nights',
  'detail.adult_one': 'adult',
  'detail.adult_other': 'adults',
  'detail.child_one': 'child',
  'detail.child_other': 'children',
  'detail.infant_one': 'infant',
  'detail.infant_other': 'infants',
} as const;
